export type AuthBroadcastType = "LOGIN" | "LOGOUT";

export type AuthBroadcastMessage = {
  type: AuthBroadcastType;
};

const CHANNEL_NAME = "finac-auth";

let channel: BroadcastChannel | null = null;

function getChannel(): BroadcastChannel | null {
  if (
    typeof window === "undefined" ||
    typeof BroadcastChannel === "undefined"
  ) {
    return null;
  }
  if (!channel) {
    channel = new BroadcastChannel(CHANNEL_NAME);
  }
  return channel;
}

/**
 * Broadcast an auth event (login/logout) to every other open tab of the app.
 * The sender tab never receives its own message, so this is safe to call
 * right after a successful login/logout in the current tab.
 */
export function postAuthMessage(type: AuthBroadcastType) {
  getChannel()?.postMessage({ type } as AuthBroadcastMessage);
}

/**
 * Listen for auth events broadcast by other tabs.
 * Returns an unsubscribe function.
 */
export function subscribeAuthMessages(
  handler: (message: AuthBroadcastMessage) => void
): () => void {
  const channelData = getChannel();
  if (!channelData) {
    return () => {};
  }
  const listener = (event: MessageEvent<AuthBroadcastMessage>) => {
    if (event?.data?.type) {
      handler(event.data);
    }
  };
  channelData.addEventListener("message", listener);
  return () => channelData.removeEventListener("message", listener);
}
